// Tipos espelhados do servidor (src/pipeline/validate.ts e src/server/sessions.ts).
// web/ é um build Vite separado, então não importa de src/ — mantém uma cópia mínima.
// Se o contrato do servidor mudar, atualizar aqui.

export interface Soap {
  subjetivo: string;
  objetivo: string;
  avaliacao: string;
  plano: string;
}

export const CAMPOS = ['subjetivo', 'objetivo', 'avaliacao', 'plano'] as const;
export type CampoSoap = (typeof CAMPOS)[number];

export type StatusSessao = 'na_fila' | 'processando' | 'pronto' | 'erro';

// Resposta de GET /api/session/:id/soap (getSoap). Datas chegam como ISO string
// (Date serializado pelo Fastify), não Date.
export interface LeituraSoap {
  status: StatusSessao;
  erro: string | null;
  soap: Soap | null; // null enquanto a estruturação não concluiu
  soapUpdatedAt: string | null;
  notaCopiadaAt: string | null;
}
